<div class="login-page">

  <div class="login-card">

    <!-- Logo / Brand -->
    <div class="login-brand">
      <div class="brand-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             width="32" height="32">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          <circle cx="12" cy="16" r="1" fill="currentColor"/>
        </svg>
      </div>
      <h1 class="brand-name">SignaTech</h1>
      <p class="brand-tagline">Sign in to your account</p>
    </div>

    <!-- Form -->
    <form class="login-form" #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm)" novalidate>

      <!-- Email -->
      <div class="form-group">
        <label for="email">Email address</label>
        <div class="input-wrapper">
          <span class="input-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                 width="18" height="18">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
          </span>
          <input
            type="email"
            id="email"
            name="email"
            class="input-with-icon"
            placeholder="you@example.com"
            [(ngModel)]="model.email"
            #emailRef="ngModel"
            required
            email
            autocomplete="email"
          />
        </div>
        <span class="form-error" *ngIf="emailRef.invalid && emailRef.touched">
          <span *ngIf="emailRef.errors?.['required']">Email is required.</span>
          <span *ngIf="emailRef.errors?.['email']">Enter a valid email address.</span>
        </span>
      </div>

      <!-- Password -->
      <div class="form-group">
        <label for="password">Password</label>
        <div class="input-wrapper">
          <span class="input-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                 width="18" height="18">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
          </span>
          <input
            [type]="showPassword ? 'text' : 'password'"
            id="password"
            name="password"
            class="input-with-icon input-with-action"
            placeholder="Enter your password"
            [(ngModel)]="model.password"
            #passwordRef="ngModel"
            required
            minlength="6"
            autocomplete="current-password"
          />
          <button type="button" class="input-action-btn" (click)="togglePassword()" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
            <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                 width="18" height="18">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
              <circle cx="12" cy="12" r="3"/>
            </svg>
            <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                 width="18" height="18">
              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
              <line x1="1" y1="1" x2="23" y2="23"/>
            </svg>
          </button>
        </div>
        <span class="form-error" *ngIf="passwordRef.invalid && passwordRef.touched">
          <span *ngIf="passwordRef.errors?.['required']">Password is required.</span>
          <span *ngIf="passwordRef.errors?.['minlength']">Password must be at least 6 characters.</span>
        </span>
      </div>

      <!-- Remember me & Forgot password -->
      <div class="login-options">
        <label class="checkbox-label">
          <input type="checkbox" name="rememberMe" [(ngModel)]="model.rememberMe" />
          <span>Remember me</span>
        </label>
        <a href="#" class="forgot-link">Forgot password?</a>
      </div>

      <!-- Submit -->
      <button
        type="submit"
        class="btn btn-primary btn-block"
        [disabled]="isLoading"
      >
        <svg *ngIf="isLoading" class="spinner" xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" width="18" height="18">
          <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
        </svg>
        {{ isLoading ? 'Signing in…' : 'Sign in' }}
      </button>

    </form>

    <!-- Footer -->
    <p class="login-footer">
      Don't have an account? <a href="#">Contact your administrator</a>
    </p>

  </div>

</div>
